export default {
    root: ({ props, context }) => ({
        class: [
            'inputtext-root',

            { 'w-full': props.fluid },

            { 'inputtext-root_invalid': props.invalid },

            { 'inputtext-root_disabled': context.disabled },
        ],
    }),
};
